import { dataFeedSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFeedSolid = /*#__PURE__*/createIcon(dataFeedSolid)
export default IconFeedSolid
